<template>
    <v-container  fluid class="pt-0">
        <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
                <v-card class="elevation-4">
                    <v-card-title>
                        <v-row>
                            <v-col cols="9" sm="9" md="9" class="">
                                Create Event
                            </v-col>
                            <v-col cols="3" sm="3" md="3" class="text-center">  
                                <v-btn @click="addRetailItem(business_id)" color="primary "  fab x-small dark class="mr-1" title="Add Retail Item">
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>

                                <v-btn @click="addFoodItem(business_id)" color="primary "  fab x-small dark class="mr-1" title="Add Food Item"><v-icon>mdi-food</v-icon></v-btn>

                                <v-btn @click="addDrinkItem(business_id)" color="primary "  fab x-small dark class="mr-1" title="Add Drink Item"><v-icon>mdi-glass-mug</v-icon></v-btn>

                                <v-btn @click="addEmployee(business_id)" color="primary "  fab x-small dark class="mr-1" title="Add Employee"><v-icon>mdi-account-tie</v-icon></v-btn>

                                <v-btn @click="addDepartment(business_id)" color="primary "  fab x-small dark class="mr-1" title="Add Department"><v-icon>mdi-desktop-mac</v-icon></v-btn> 

                                <v-btn @click="editBusiness(business_id)" color="primary "  fab x-small dark class="mr-1" title="Business Edit">
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn> 
                                          
                                <!-- <v-btn @click="addEvent(business_id)" color="primary " fab x-small dark class="mr-1" title="Add Event"><v-icon>mdi-calendar-plus</v-icon></v-btn> -->
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-divider></v-divider>
                            <v-form v-model="valid" enctype="multipart/form-data" id="createEvent">
                                <v-container>
                                    <v-card elevation="3" class="pa-3 mb-3">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                <h4 class="title red--text ">Event Information</h4>
                                            </v-col>
                                        </v-row>
                                        
                                        <v-row>
                                            <v-col>
                                                <h4> Business {{businessname}}</h4>
                                            </v-col>
                                            <!-- <v-col cols="12" md="12" sm="12">
                                                <v-label class="font-weight-bold">Event Title</v-label>
                                            </v-col> -->
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                    v-model="title"
                                                    name="title"
                                                    label="Title"
                                                   
                                                ></v-text-field>
                                                <!-- <ckeditor :editor="editor" v-model="title" :config="editorConfig" name="" ></ckeditor> -->
                                                <!-- <editor
                                                    api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                                    initialValue=""
                                                    v-model="title"
                                                    :init="editorConfig"
                                                ></editor> -->
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                    v-model="subtitle"
                                                    name="subtitle"
                                                    label="Sub Title"
                                                   
                                                ></v-text-field>
                                               
                                            </v-col>
                                            
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" md="6" sm="6">
                                                <v-text-field
                                                    v-model="venue"
                                                    name="venue"
                                                    label="Event Venue"
                                                   
                                                ></v-text-field>
                                               
                                            </v-col>
                                            <v-col cols="6" md="6" sm="6">
                                            
                                                <v-autocomplete 
                                                    label="Event Frequency"
                                                    v-model="eventfrequency_id"  
                                                    name="eventfrequency_id"  
                                                    item-text="name"
                                                    item-value="id"  
                                                    :items="frequencies"  
                                                ></v-autocomplete>
                                           
                                            </v-col>
                                        </v-row>
                                        <v-row>    
                                            <v-col cols="12" md="3">
                                                <v-text-field
                                                v-model="time"
                                                name="time"
                                                label="Start Time"
                                               ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <v-text-field
                                                v-model="endtime"
                                                name="endtime"
                                                label="End Time"
                                               ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <v-menu
                                                    v-model="menu2"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        
                                                        <v-text-field
                                                            v-model="computedDateFormatted"
                                                            label="Event Start Date"
                                                            prepend-icon="event"
                                                            hint="DD/MM/YYYY"
                                                            persistent-hint
                                                            clearable
                                                            @click:clear="startdate = null"
                                                            readonly
                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker no-title v-model="startdate" name="startdate"  @input="menu2 = false"></v-date-picker>
                                                </v-menu> 
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <v-menu
                                                    v-model="menu3"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        
                                                        <v-text-field
                                                            v-model="computedDateFormattedEnd"
                                                            label="Event End Date"
                                                            prepend-icon="event"
                                                            hint="DD/MM/YYYY"
                                                            persistent-hint
                                                            clearable
                                                            @click:clear="enddate = null"
                                                            readonly

                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker no-title v-model="enddate" name="enddate"  @input="menu3 = false"></v-date-picker>
                                                </v-menu> 
                                                <!-- <v-text-field
                                                    v-model="enddate"
                                                    name="enddate"
                                                    label="Event End Date"
                                                    placeholder="dd/mm/yyyy"
                                                    v-mask="mask"
                                                    ></v-text-field> -->
                                            </v-col>
                                           
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3">
                                                    <v-text-field
                                                    v-model="bookingurl"
                                                    name="bookingurl"
                                                    label="Booking Url"
                                                    ></v-text-field>
                                                </v-col>
                                                
                                                <v-col cols="12" md="3">
                                                    <v-text-field
                                                    v-model="bookingtext"
                                                    name="bookingtext"
                                                    label="Booking Text"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-text-field
                                                    v-model="url"
                                                    name="url"
                                                    label="Url"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" md="3">
                                                    <v-text-field
                                                    v-model="urltext"
                                                    name="urltext"
                                                    label="Url Text"></v-text-field>
                                                </v-col>
                                            
                                            </v-row>    
                                       
                                            <v-row>
                                                <v-col cols="12" md="3">
                                                    <v-select v-model="show" item-text="name" item-value="value" :items="shows" label="Show/Hidden"></v-select>
                                                </v-col>

                                                <v-col cols="12" md="3">
                                                    <v-select v-model="share" item-text="name" item-value="value" :items="shares" label="Shareable"></v-select>
                                                </v-col>

                                                <v-col cols="12" md="3" sm="3">
                                            
                                                    <v-autocomplete 
                                                        label="Event Category"
                                                        v-model="eventcategory_id"  
                                                        name="eventcategory_id"  
                                                        item-text="name"
                                                        item-value="id"  
                                                        :items="eventcategories"  
                                                    ></v-autocomplete>
                                           
                                                </v-col>

                                                <v-col cols="12" md="3" sm="3">
                                            
                                                    <v-autocomplete 
                                                        label="Event Type"
                                                        v-model="eventtype_id"  
                                                        name="eventtype_id"  
                                                        item-text="name"
                                                        item-value="id"  
                                                        :items="eventtypes"  
                                                    ></v-autocomplete>
                                           
                                                </v-col>
                                            </v-row> 
               
                                        

                                            <v-row>
                                                <v-col cols="12" md="12">
                                                    <h4 class="title">Price Value</h4>
                                                </v-col>
                                            </v-row>
                
                

                                    <v-card elevation="3" class="pa-3 mb-3">
                                        <v-row v-for="(item, index) in price" :key="index">
                                            
                                                    <v-col cols="12" md="6" >
                                                        <v-text-field
                                                        v-model="item.pricename"
                                                        :name="'pricename['+index+']'"
                                                        label="Price Name"
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="5" sm="5">
                                                        <v-text-field
                                                            v-model="item.pricevalue"
                                                            :name="'pricevalue['+index+']'"
                                                            label="Price Value">
                                                           
                                                        </v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="1" sm="1" justify="right" align="right">
                                                        <v-row class="">
                                                            <v-col cols="12" md="12" sm="12">
                                                                <a @click="price.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                                                            </v-col>
                                                        </v-row>
                                                
                                                    </v-col>
                                                
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="12" sm="12">
                                                <v-btn class="add " color="primary" @click="add">Add Price</v-btn>
                                            </v-col>
                                        </v-row>
                                        
                                    </v-card>

                                    <v-row>
                                        <v-col cols="12" md="12" sm="12">
                                            <v-label class="font-weight-bold">Price Description</v-label>
                                        </v-col>
                                    </v-row>    

                                    <v-row>
                                            <v-col cols="12" md="12">
                                              
                                                <editor
                                                api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                                initialValue=""
                                                v-model="pricedescription"
                                                :init="editorConfigDescription"
                                                ></editor>
                                            </v-col>
                                    </v-row> 

                                    <v-divider></v-divider>

                                    <!-- <v-row>
                                        <v-col cols="12" md="12" sm="12">
                                            <v-label class="font-weight-bold">Event Short Description</v-label>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="12" sm="12">
                                    
                                            <editor
                                            api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                            initialValue=""
                                            v-model="shortdescription"
                                            :init="editorConfigDescription"
                                            ></editor>
                                        </v-col>
                                    </v-row> -->

                                    <v-row>
                                            <v-col cols="12" md="12" sm="12">
                                                <v-label class="font-weight-bold">Event Description</v-label>
                                            </v-col>
                                    </v-row>      
                                    <v-row>
                                            <v-col cols="12" md="12">
                                                
                                                <editor
                                                api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                                initialValue=""
                                                v-model="description"
                                                :init="editorConfigDescription"
                                                ></editor>
                                            </v-col>
                                    </v-row>
                                    <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <h3 class="title red--text">Select Attachment</h3>
                                            </v-col>
                                    </v-row>
                                    <v-row>    
                                             <v-col cols="12" md="4">
                                                <v-text-field
                                                v-model="imagetext"
                                                name="imagetext"
                                                label="Attachment Text"
                                                placeholder="Attachment Text"
                                               
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="8" md="8">
                                             <v-file-input
                                                accept="image/png, image/jpeg, image/bmp"
                                                placeholder="Pick an Logo"
                                                prepend-icon="mdi-attachment"
                                                label="Attachment"
                                                name="imagea"
                                                id="imagea">
                                             </v-file-input>
                                            </v-col>
                                    </v-row>        
                                    <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <h3 class="title red--text">Select Event Image</h3>
                                            </v-col>
                                    </v-row>
                                    <!-- <v-row>
                                            <v-col cols="12" md="12" sm="12">
                                                <v-file-input
                                                accept="image/png, image/jpeg, image/bmp"
                                                placeholder="Pick an Event Image"
                                                prepend-icon="mdi-camera"
                                                label="Event Image"
                                                name="image"
                                                id="image">
                                                </v-file-input>
                                            </v-col>
                                    </v-row>    -->

                                    <v-row>
                                        <v-col cols="12" md="6" sm="6">
                                                
                                            <Cropper classname="cropper" :src="mainimg" @change="onChangeImage" :stencilProps="{aspectRatio: 1}"/>

                                                
                        
                                            <v-row>
                                                <v-col cols="12" md="12" sm="12" align="center">
                                                    <v-btn color="primary" @click="$refs.imgfile.click()"> 
                                                                                        
                                                        <input type="file" ref="imgfile" @change="mainim($event)" accept="image/*" class="d-none" id="image"/>Upload  Image
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                            <v-col col="12" md="6" sm="6">
                                                <img style="max-width:100%"  :src="image"  class="grey lighten-2"  max-height="300"  v-if="image!=null" />
                                            </v-col>
                                    </v-row>

                                    </v-card>
                                    
                                    <v-divider></v-divider>

                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <h4 class="title">Gallery</h4>
                                        </v-col>
                                    </v-row>
                
                

                                    <v-card elevation="3" class="pa-3 mb-3">

                  
                                        <v-row v-for="(item, index) in galleries" :key="index">
                                                                
                                            <v-col cols="12" md="11">
                                            
                                                    
                                                <v-file-input
                                                accept="image/png, image/jpeg, image/bmp"
                                                placeholder="Pick an Gallery Image"
                                                prepend-icon="mdi-camera"
                                                label="Gallery Image"
                                                :id="'img'+index"
                                                :name="'imageurl['+index+']'"
                                                
                                                ></v-file-input>
                                                                
                                            </v-col>
                                                                            
                                            <v-col cols="12" md="1" sm="1" justify="right" align="right">
                                                <v-row class="">
                                                <v-col cols="12" md="12" sm="12">
                                                    <a @click="galleries.splice(index, 1)"><v-icon  style="color:red">mdi-delete</v-icon></a>
                                                </v-col>
                                                </v-row>
                                                                        
                                            </v-col>
                                                                    
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="12" sm="12">
                                                <v-btn class="add " color="primary" @click="addgallery">Add Gallery</v-btn>
                                            </v-col>
                                        </v-row>
                                        
                                    </v-card>
                                <v-divider></v-divider>
                                        <div class="my-3">
                                        <v-btn color="primary" @click="submit">Save</v-btn>
                                        </div>
                                </v-container>
                            </v-form>
                    </v-card-text>
                   
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import Vue from 'vue'
import VeeValidate from "vee-validate";
import { Cropper } from 'vue-advanced-cropper'
import { mask } from 'vue-the-mask';
import Editor from '@tinymce/tinymce-vue'

//Vue.use( CKEditor );

Vue.use(VeeValidate);
export default {
    directives: {
      mask,
    },    
     data: vm => ({
        venue:"", 
        // enddate:new Date().toISOString().substr(0, 10),  
        // startdate: new Date().toISOString().substr(0, 10), 
        enddate:null,  
        startdate: null,  
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        subtitle:"",
        bookingtext:"",
        bookingurl:"",
        endtime:"",
        time:"", 
        menu3: false, 
        menu2: false, 
        businessname:"", 
        subtitle:"",
        editorData: '',
        editorConfig: {
            height: 100,
         menubar: false,
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code wordcount autoresize'
         ],
         toolbar:
           'undo redo | bold italic | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | link image anchor'
        },
         editorConfigDescription: {height: 100,
         menubar: false,
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code wordcount autoresize'
         ],
         toolbar:
           'undo redo | formatselect | bold italic forecolor backcolor| \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | link image anchor'},   
        urltext:"", 
        imagetext:"", 
        mask: '##/##/####',
        search:null,
       
       
        url:"",
        btnColor:"", 
        valid:true,
       
        title:'',
        lastname:'',
        dataofjoining:'',
        description:'', 
       
        business_id:"",
        
        
        uploadedimage:null,
        image:null,
        frequencies:[],
        eventfrequency_id:0,
        price_id:"",
        price:[{'id':'','pricename':'','pricevalue':''}],
        show:'1',
        shows:[{name:"Yes",value:"1"}, {name:"No",value:"0"}],
        eventcategory_id:0,
        eventcategories:[],
        eventtype_id:0,
        eventtypes:[],
        pricedescription:'',
        galleries:[{'imageurl':''}],
        imageurl:'',
        files: [],
        share:'0',
        shares:[{name:"Yes",value:1}, {name:"No",value:0}],
        shortdescription:'',
        mainimg:null,
        image:null,
        coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
        },
     }),
    components: {
       'editor': Editor,
       Cropper
    },
    computed: {
       computedDateFormatted () {
         return this.formatDate(this.startdate)
      },
      
      computedDateFormattedEnd(){
           return this.formatDate(this.enddate)
      },
     
     },
    watch: 
    {
      startdate (val) {
        this.dateFormatted = this.formatDate(this.startdate)
      },
      enddate(val)
      {
        this.dateFormatted = this.formatDate(this.enddate)
      }
    },
    created() 
    { 
        if(this.$route.params.business_id)
        {
            this.business_id=this.$route.params.business_id;
        }
       
       this.$http
       .get(this.$apidomain+"getbusinessname/"+this.business_id)
       .then(res => {
       this.businessname=res.data.businessName;
       })
       .catch(err => {
        console.log(err.response);
       });
       this.fetchEventFrequency(); 
       this.fetchEventCategory();
       this.fetchEventType();
    },
   
    methods: {
        editBusiness(id)
        {
            this.$router.push({name:'editbusiness',params:{id:id}});
        },
        addRetailItem(id)
        {
            this.$router.push({name:'retailitemlist',params:{business_id:id}});
        },

        addFoodItem(id)
        {
          //this.$router.push({name:'createitem',params:{business_id:id}});
          this.$router.push({name:'itemlist',params:{business_id:id}});
        },
        addDrinkItem(id)
        {
        this.$router.push({name:'drinkitemlist',params:{business_id:id}});
        },
        addEmployee(id)
        {
        this.$router.push({name:'employeelist',params:{business_id:id}});
        },
        addDepartment(id)
        {
        this.$router.push({name:'departmentlist',params:{business_id:id}});
        },
        addEvent(id)
        {
        this.$router.push({name:'eventlist',params:{business_id:id}});
        },
        addgallery()
        {
         this.galleries.push({'imageurl':''})
        },
        add()
        {
            this.price.push({
            'id':'',
            'pricename':'',
            'pricevalue':''
            })
        },
        fetchEventCategory()
        {
            this.$http
            .get(this.$apidomain+"eventcategorylist")
            .then(res => {
                this.eventcategories = res.data.eventCategory;
                
               

                   
                
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        fetchEventType()
        {
            this.$http
            .get(this.$apidomain+"eventtypelist")
            .then(res => {
                this.eventtypes = res.data.eventtype;
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        fetchEventFrequency()
        {
            this.$http
            .get(this.$apidomain+"frequencyList")
            .then(res => {
                this.frequencies = res.data.frequency;
             })
            .catch(err => {
                console.log(err.response);
            });
        },
        formatDate (date) {
            if (!date) return null

            const [year,month,day ] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) 
        {
            if (!date) return null

            const [ day, month,year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        onChangeImage({coordinates, canvas})
        {
            this.coordinates = coordinates
        
            this.image = canvas.toDataURL()
        },
        mainim(event)
        {
            var input = event.target;
            // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0]) 
            {
                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.mainimg = e.target.result;
                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(input.files[0]);
            }
        },
        dataURLtoFile(dataurl, filename) 
        {
  
            var arr = dataurl.split(','),
                  mime = arr[0].match(/:(.*?);/)[1],
                  bstr = atob(arr[1]), 
                  n = bstr.length, 
                  u8arr = new Uint8Array(n);
                  
            while(n--){
                  u8arr[n] = bstr.charCodeAt(n);
            }
          
            return new File([u8arr], filename, {type:mime});
        },
        submit()
        {
            let th = this;
            if (this.$validator.validateAll()) {
                let fd = new FormData(document.getElementById("createEvent"));

                fd.append('prices',JSON.stringify(this.price));
                fd.append('show',this.show);
                fd.append('share',this.share);
                
                fd.append('businesses_id',this.business_id);
                fd.append('startdate',this.startdate);
                fd.append('enddate',this.enddate);
                //fd.append('title',this.title);
                fd.append('description',this.description);
                fd.append('shortdescription',this.shortdescription);

                fd.append('pricedescription',this.pricedescription);
                fd.append('eventfrequency_id',this.eventfrequency_id);
                fd.append('eventtype_id',this.eventtype_id);
                fd.append('eventcategory_id',this.eventcategory_id);

                if(this.mainimg!=null)
                {
                    fd.append('image',this.dataURLtoFile(this.image,document.getElementById('image').files[0].name));    
                }
                
                this.$http
                .post(this.$apidomain+"agent/createEvent", fd)
                .then(res => {
                    if(res.data.success)  
                    {
                    
                    
                     this.$router.push("/agent/eventlist/"+this.business_id);
                    }  
                    else
                    {
                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        alert(errmsg[0]);
                    }
                })
                .catch(err => {
                    console.log(err.response);
                });
            }
        }
    }
}
</script>
<style >
    .cropper {
	border: solid 1px #EEE;
	height: 300px;
	width: 100%;
}
</style>